import { Switch } from '../../../../components';
import {
    BreathingCircle,
    Exercise,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    ProgressBar,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { IllustrationPersonThinking, IllustrationThinking } from '../../icons';
import { ExerciseViewProps } from '../exercises';

export function Module2S1Exercise4({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    return (
        <Exercise title="Tæl til ti">
            <ProgressBar current={exercise.CurrentPage} total={4} />
            <Switch
                value={exercise.CurrentPage}
                default={1}
                cases={{
                    1: (
                        <Page1
                            onContinue={() =>
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 2,
                                })
                            }
                        />
                    ),
                    2: (
                        <Page2
                            onContinue={() =>
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 3,
                                })
                            }
                        />
                    ),
                    3: (
                        <Page3
                            onContinue={() =>
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 4,
                                })
                            }
                        />
                    ),
                    4: (
                        <Page4
                            onContinue={() =>
                                onContinue({
                                    status: ExerciseStatus.Completed,
                                    goToNext: '2.1.completed',
                                })
                            }
                        />
                    ),
                }}
            />
        </Exercise>
    );
}

type PageProps = {
    onContinue: () => void;
};

function Page1({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Flyt fokus fra tankerne</LabelDisplay2>
            <LabelBody>
                Her er en simpel øvelse til at få fokus væk fra tankerne, når de
                har fanget dig ind. Her øver du dig i at give slip på
                bekymringerne og komme tilbage til nuet.
            </LabelBody>
            <IllustrationThinking className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Gå i gang</SecondaryButton>
        </>
    );
}

function Page2({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay1 class="mb-10">Sådan gør du</LabelDisplay1>
            <LabelBody>
                Du skal nu trække vejret roligt ind og ud igennem næsen, mens du
                tæller til ti. Træk vejret ind på de ulige tal og pust ud på de
                lige tal. Som en hjælp kan du følge cirklens bevægelser.
            </LabelBody>
            <BreathingCircle class="my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Nu har jeg prøvet det af
            </SecondaryButton>
        </>
    );
}

function Page3({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay1 class="mb-10">Prøv det om og om igen</LabelDisplay1>
            <LabelBody>
                Forsøg nu igen at tælle til ti. Hver gang det bliver svært at
                fastholde tællingen, fordi du opdager, at du sidder fast i en
                tanke, kan du for dig selv sige 'Tænker' og starte forfra med at
                tælle fra et. Det at tælle giver dig et andet fokus end
                tankerne, og ved at sige 'Tænker' bliver du opmærksom på,
                hvornår de flyver. Det er helt normalt at skulle tælle om og om
                igen.
            </LabelBody>
            <IllustrationPersonThinking className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

function Page4({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Et godt redskab</LabelDisplay2>
            <LabelBody>
                Vi ved af erfaring, at denne øvelse kan være svær at holde af.
                Men den kan være effektfuld, hvis man får erfaring med den. Det
                gode ved den er, at du hverken behøver at ligge ned eller være
                alene. Den kan laves alle steder, også når der er andre
                mennesker til stede – de kan ikke høre, hvad der foregår inde i
                dig. 
            </LabelBody>
            <Spacer class="mt-30" />
            <SecondaryButton onClick={onContinue}>
                Afslut øvelsen
            </SecondaryButton>
        </>
    );
}
